import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-56f36fad"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "pie-demo",
  ref: "contentRef"
};
var _hoisted_2 = {
  class: "chart"
};
var _hoisted_3 = {
  id: "container",
  onselectstart: "return false"
};
var _hoisted_4 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_table_column = _resolveComponent("el-table-column");
  var _component_el_table = _resolveComponent("el-table");
  var _component_Overlay = _resolveComponent("Overlay");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_withDirectives(_createElementVNode("canvas", _hoisted_3, null, 512), [[_vShow, _ctx.dataStatus]]), _withDirectives(_createElementVNode("img", {
    class: "image-demo",
    src: require('@/assets/img/empty.png')
  }, null, 8, _hoisted_4), [[_vShow, !_ctx.dataStatus]])]), _createVNode(_component_el_table, {
    data: _ctx.tableData,
    border: true,
    size: "small"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_table_column, {
        type: "index",
        label: "序号"
      }), _createVNode(_component_el_table_column, {
        prop: "customer_name",
        label: "客户"
      }), _createVNode(_component_el_table_column, {
        prop: "stone_name",
        label: "料类"
      }), _createVNode(_component_el_table_column, {
        prop: "net_weight",
        label: "净重(吨)"
      }), _createVNode(_component_el_table_column, {
        prop: "customer_pay",
        label: "金额(元)"
      })];
    }),
    _: 1
  }, 8, ["data"]), _createVNode(_component_Overlay, {
    showOverlay: _ctx.showOverlay
  }, null, 8, ["showOverlay"])], 512);
}